//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as api from '~/api/index';
import newsList from '~/components/news/news-list.vue';
import hotArticle from '~/components/public/hot-article.vue';
import infiniteDtb from '~/components/public/infinite-dtb.vue';
import AdListItemMixins from '~/mixins/ad-list-item';
export default {
  components: {
    infiniteDtb,
    newsList,
    hotArticle,
  },
  mixins: [AdListItemMixins],

  async asyncData({ query, error, $axios }) {
    try {
      // 获取类型
      const newsType = +query.type;
      // const zhTypeName = zhTypes[newsType];
      const [nordataResult, newsLabelResult] = await Promise.all([
        $axios(
          api.getNews({
            timestamp: '',
            count: 15,
            type: newsType || '',
          })
        ),
        $axios(api.getNewsLabel()),
      ]);

      const newsLable = newsLabelResult?.result ?? [];
      newsLable.push({
        id: 38,
        typeName: '美股异动',
        typeDescription: '美股市场股票异动',
        filterLabel: null,
      });
      return {
        newsType,
        newsLable,
        nordata: nordataResult.result,
      };
      // getNewsLabel()
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
      error({
        statusCode: 404,
        message: '文章不存在',
      });
    }
  },

  head() {
    return {
      title: '格隆汇事件-重大事件及时分析解读-财经市场参考',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.newsType
            ? `格隆汇事件栏目下具体介绍了金融行业内${this.zhTypeName}、行业评级、外汇数据监控、外汇市场分析等, 如果有对此感兴趣的人可到格隆汇官网查看, 因为站内更详细的展开了剖析.`
            : '格隆汇事件栏目下对欧洲股市行情, 港股异动, 新股怎样申购, 申购股票等相关内容进行了客观的监控及介绍, 要了解详细内容 的请到格隆汇官网进行查阅.',
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.newsType
            ? `${this.zhTypeName},外汇实时查询,外汇数据监控,外汇市场分析`
            : '欧洲股市行情,港股异动,新股怎样申购,申购股票',
        },
      ],
      link: [
        {
          rel: 'canonical',
          href: 'https://www.gelonghui.com/news/',
        },
        {
          rel: 'alternate',
          media: 'only screen and (max-width:640px)',
          href: 'https://m.gelonghui.com/news/',
        },
      ],
    };
  },

  computed: {
    newsListWithAdd() {
      // 插入广告
      const test = this.insertAdToData(this.nordata, this.news_ad, 2, 6);
      return test;
    },
  },
  mounted() {},
  methods: {
    async getMoreNews() {
      const createdTime = this.nordata[this.nordata.length - 1].createDate - 1;

      const results = await this.$axios(
        api.getNews({
          timestamp: createdTime,
          count: 15,
          type: this.$route?.query?.type ? +this.$route?.query?.type : '',
        })
      );
      this.nordata = [...this.nordata, ...results.result];
    },
  },
};
